import { UseGqlMutationCallbacks, useMutationWithInvalidation } from '@alice-financial/api'
import { useIntl } from 'react-intl'
import { useMutationNotifier } from '../../../../notifications/useMutationNotifier'
import {
  CompleteOnboardingStepMutation,
  CompleteOnboardingStepMutationVariables,
  useCompleteOnboardingStepMutation,
} from './completeOnboardingStep_gen'

type UseCompleteOnboardingStepOptions = UseGqlMutationCallbacks<
  CompleteOnboardingStepMutation,
  Pick<CompleteOnboardingStepMutationVariables['input'], 'stepType' | 'dataChange'>
>

export const useCompleteOnboardingStep = (
  orgId: number,
  mutationOptions?: UseCompleteOnboardingStepOptions
) => {
  const intl = useIntl()
  const { mutateAsync: completeOnboardingStep } = useCompleteOnboardingStepMutation()

  const optionsWithNotifications = useMutationNotifier(
    {
      onMutate: intl.formatMessage({ id: 'organization.onboarding.completing_step' }),
      onSuccess: intl.formatMessage({ id: 'organization.onboarding.step_completed' }),
    },
    mutationOptions
  )

  return useMutationWithInvalidation(
    ({ stepType, dataChange }) => completeOnboardingStep({ input: { stepType, orgId, dataChange } }),
    optionsWithNotifications,
    'all' // Invalidate all queries when onboarding step is completed
  )
}
